<script setup>
defineProps({
  label: { type: String, default: '' },
  /** id of the control, links the label to it */
  for: { type: String, default: null },
  hint: { type: String, default: '' },
  error: { type: String, default: '' },
  optional: { type: Boolean, default: false },
  /** light or dark surface */
  surface: { type: String, default: 'light' },
});
</script>

<template>
  <div class="pd-field" :class="[`pd-field--${surface}`, { 'has-error': error }]">
    <div v-if="label || $slots.aside" class="pd-field__top">
      <label v-if="label" class="pd-field__label" :for="$props.for">
        {{ label }}<span v-if="optional" class="pd-field__opt">Optional</span>
      </label>
      <slot name="aside" />
    </div>
    <slot />
    <p v-if="error" class="pd-field__error" role="alert">{{ error }}</p>
    <p v-else-if="hint" class="pd-field__hint">{{ hint }}</p>
  </div>
</template>

<style scoped>
.pd-field { display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.pd-field__top { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; }
.pd-field__label { font-weight: 800; font-size: 0.875rem; }
.pd-field__opt { margin-left: 8px; font-weight: 600; color: var(--pd-subtle); font-size: 0.75rem; }
.pd-field__hint { font-size: 0.8125rem; color: var(--pd-muted); }
.pd-field__error { font-size: 0.8125rem; font-weight: 700; color: var(--pd-danger); }
.pd-field--dark .pd-field__label { color: var(--pd-white); }
.pd-field--dark .pd-field__hint { color: var(--pd-ink-muted); }
</style>
